export var BusinessReviewEntryType;
(function (BusinessReviewEntryType) {
    BusinessReviewEntryType["MANUAL"] = "MANUAL";
    BusinessReviewEntryType["FACEBOOK"] = "FACEBOOK";
    BusinessReviewEntryType["GOOGLE"] = "GOOGLE";
    BusinessReviewEntryType["RAVELY"] = "RAVELY";
    BusinessReviewEntryType["RAVELY_VIDEO"] = "RAVELY_VIDEO";
    BusinessReviewEntryType["YOUTUBE_VIDEO"] = "YOUTUBE_VIDEO";
    //FE Only
    BusinessReviewEntryType["SEE_ALL"] = "SEE_ALL";
})(BusinessReviewEntryType || (BusinessReviewEntryType = {}));
